'use strict';

var React = require('react');

var SvgCircleChevronRightIcon = function SvgCircleChevronRightIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M8.22 12.47a.75.75 0 1 0 1.06 1.06l3-3a.75.75 0 0 0 .001-1.06l-3-3.012a.75.75 0 0 0-1.062 1.059l2.472 2.482-2.471 2.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M17 10a7 7 0 1 1-14 0 7 7 0 0 1 14 0Zm-1.5 0a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0Z"
  }));
};
SvgCircleChevronRightIcon.displayName = "CircleChevronRightIcon";

exports.SvgCircleChevronRightIcon = SvgCircleChevronRightIcon;
